type Props = {
    color: string;
};

export const FamilyIcon = ({ color }: Props) => (
    <svg id="SVGRoot" width="100%" height="100%" version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <g>
            <g>
                <rect fill={color} x="160" width="32" height="32" />
                <rect fill={color} x="128" y="32" width="32" height="32" />
                <rect fill={color} x="192" y="32" width="32" height="32" />
            </g>
            <rect fill={color} x="320" y="288" width="96" height="32" />
            <g>
                <rect fill={color} x="160" y="64" width="32" height="32" />
                <rect fill={color} x="96" y="128" width="32" height="32" />
                <rect fill={color} x="224" y="128" width="32" height="32" />
                <rect fill={color} x="32" y="256" width="32" height="32" />
                <rect fill={color} x="288" y="256" width="32" height="32" />
                <rect fill={color} x="416" y="320" width="32" height="32" />
                <rect fill={color} x="352" y="224" width="32" height="32" />
            </g>
            <g>
                <rect fill={color} x="320" y="384" width="32" height="64" />
                <rect fill={color} x="384" y="384" width="32" height="64" />
                <rect fill={color} x="160" y="128" width="32" height="64" />
            </g>
            <g>
                <rect fill={color} x="128" y="384" width="32" height="96" />
                <rect fill={color} x="64" y="160" width="32" height="96" />
                <rect fill={color} x="256" y="160" width="32" height="96" />
                <rect fill={color} x="352" y="288" width="32" height="96" />
                <rect fill={color} x="192" y="384" width="32" height="96" />
            </g>
            <rect fill={color} x="160" y="160" width="32" height="64" />
            <rect fill={color} x="128" y="192" width="96" height="96" />
            <rect fill={color} x="128" y="234" width="96" height="96" />
            <rect fill={color} x="96" y="288" width="160" height="96" />
            <rect fill={color} x="128" y="352" width="32" height="96" />
            <rect fill={color} x="192" y="352" width="32" height="96" />
            <g>
                <rect fill={color} x="384" y="192" width="32" height="32" />
                <rect fill={color} x="352" y="160" width="32" height="32" />
                <rect fill={color} x="320" y="192" width="32" height="32" />
            </g>
        </g>
    </svg>
);
